import {loginApi} from './api-config';

async function searchWhiteList (reqBody) {
  const res = await fetch('/api/admin/searchWhiteList', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV', 'x-requested-with': 'XMLHttpRequest' }
  })
  await errorHandler(res)
  return res.json();
}

async function updateWhiteList(reqBody){
  const res = await fetch('/api/admin/updateWhiteList', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV', 'x-requested-with': 'XMLHttpRequest' } 
  })
  await errorHandler(res)
  return res.status == 200;
}

async function insertWhiteList(reqBody) {
  const res = await fetch('/api/admin/insertWhiteList', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV', 'x-requested-with': 'XMLHttpRequest'  }
  })
  await errorHandler(res)
  return res.status == 200
}


async function errorHandler(res) {
  if (res.status === 401) {
    window.location.href = loginApi;
  } else if(res.status === 403){
    const data = res.headers.get('Content-Type')?.includes('json') && res.json ? await res.json() : undefined
    if(data.error === 'User does not have permission.'){
      window.location.href = '/admin/no-permission';
    }
  } 
  return res
}

export  {
  searchWhiteList,
  updateWhiteList,
  insertWhiteList
}